export const HOVER_OPACITY = 0.08;
export const PRESSED_OPACITY = 0.24;
export const SELECTED_OPACITY = 0.12;
